import { render, staticRenderFns } from "./OrderChangeStatusCancelled.vue?vue&type=template&id=7cd70796&scoped=true"
import script from "./OrderChangeStatusCancelled.vue?vue&type=script&lang=js"
export * from "./OrderChangeStatusCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd70796",
  null
  
)

export default component.exports